<template>
  <div class="indexDetail1">
    <!-- 可替换banner 对应后台产品图片字段-->
    <section class="banner inner-banner">
      <img :src="list.bannerImg" />
    </section>
    <!-- 可替换banner 对应后台产品图片字段-->

    <!-- 富文本框编辑内容区域 -->
    <div class="content-edit" v-html="wcwkDetail"></div>
    <!-- 富文本框编辑内容区域 -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  metaInfo() {
    return {
      title: "超声高频外科集成手术设备-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {
  },
  data() {
    return {
      wcwkDetail:"",
      list:{}
    };
  },
  created() {
    let data = {
        Title: this.$route.query.title,
        ForumTypeCode:'JXWCWK'
    }
    this.getQWcwkList(data)
    this.getBanner()
  },
  methods: {
    getBanner(){
      let data = {
        Title: this.$route.query.title + 'Banner图',
        ForumTypeCode:'JXWCWK'
      }
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.list = JSON.parse(res.data.OutputData.Content)
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    getQWcwkList(data) {
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.wcwkDetail = res.data.OutputData.Content
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
@import "../../assets/less/base.less";
@import "../../assets/less/common.less";

.indexDetail1 {
  line-height: 1.7;
  .banner {
    img {
      max-width: auto;
      min-width: 100%;
      height: auto;
      min-height: 100%;
    }
  }
  .e-main {
    color: #323232;
    text-align: justify;
    h3 {
      display: flex;
      align-items: center;
      width: 100%;
      color: #323232;
      white-space: nowrap;
    }
    h3.e-flex-title:after {
      content: "";
      width: 100%;
      height: 1px;
      background: #dcdcdc;
    }
    .e-flex-ul {
      .e-flex-img {
        max-width: 50%;
        width: 100%;
        text-align: center;
      }
      .e-flex-txt {
        width: 100%;
      }
    }
    .e-flex-ul.e-flex-full .e-flex-img {
      max-width: 100%;
      width: 100%;
    }
    h4 {
      line-height: 1.7;
    }
    p {
      font-size: inherit;
      color: inherit;
      line-height: inherit;
      margin: 0;
    }
    .e-case-item p + p {
      margin-top: 18px;
    }
  }

  @media only screen and (min-width: 960px) {
    .banner {
      padding-top: 130px;
    }
    .e-main {
      margin-top: 60px;
      font-size: 22px;
      line-height: 40px;
      .w1200 {
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        h3 {
          margin-bottom: 45px;
          font-size: 28px;
        }
        h3.e-flex-title:after {
          margin-left: 12px;
        }
        .e-flex-ul {
          .e-flex-txt {
            max-width: 50%;
            .e-ul-num li {
              display: flex;
              align-items: flex-start;
              p {
                font-size: inherit;
                color: inherit;
                line-height: inherit;
                margin: 0;
                span {
                  color: inherit;
                  line-height: inherit;
                  margin: 0;
                }
              }
            }
          }
        }
        .e-flex-ul.e-flex-full .e-flex-img {
          margin-bottom: 24px;
        }
      }
    }
  }
  @media screen and (max-width: 960px) and (min-width: 320px) {
    .banner {
      padding-top: 3.52rem;
    }
    .e-main {
      margin-top: 2.4rem;
      font-size: 1.0399rem;
      line-height: 1.8;
      .w1200 {
        width: 100%;
        padding-right: 1.44rem;
        padding-left: 1.44rem;
        h3 {
          margin-bottom: 1.44rem;
          font-size: 1.32rem;
        }
        h3.e-flex-title:after {
          margin-left: 0.6rem;
        }
        .flexbox {
          flex-wrap: wrap;
        }
        .e-flex-ul {
          .e-flex-img {
            max-width: 100%;
            flex: none;
            margin-bottom: 0.72rem;
          }
          .e-flex-txt {
            max-width: 100%;
          }
        }

        .e-case-item p + p {
          margin-top: 1.02rem;
        }
      }
    }
  }
}
</style>